// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminB2bPaymentListItemResponse

import { BillingPaymentStatus, BillingDisputeStatus } from './enums.gen';
import { hydrateAdminBusinessReference, type AdminBusinessReference, type AdminBusinessReferenceApiResponse } from './adminBusinessReference.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AdminB2bPaymentListItemApiResponse = {
	id: number;
	business: AdminBusinessReferenceApiResponse;
	amount: number;
	paymentStatus: BillingPaymentStatus;
	createdAt: string;
	updatedAt: string;
	disputeStatus: BillingDisputeStatus | null;
	stripePaymentIntentId: string | null;
};

export type AdminB2bPaymentListItem = {
	id: number;
	business: AdminBusinessReference;
	amount: number;
	paymentStatus: BillingPaymentStatus;
	createdAt: DateTime;
	updatedAt: DateTime;
	disputeStatus: BillingDisputeStatus | null;
	stripePaymentIntentId: string | null;
};

export function hydrateAdminB2bPaymentListItem(data: AdminB2bPaymentListItemApiResponse): AdminB2bPaymentListItem {
	return {
		...data,
		business: hydrateAdminBusinessReference(data.business),
		createdAt: DateTimefromISO(data.createdAt)!,
		updatedAt: DateTimefromISO(data.updatedAt)!,
	};
}